import React, { useState, useEffect, useContext } from 'react'

import styles from './BeneficiarioModal.module.css'
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'

import GeneralContext from '../../context/GeneralContext'
import Modal from '../Modals'
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker, { utils } from "@hassanmojab/react-modern-calendar-datepicker";
import * as BeneficiarioRepository from "../../services/repositories/beneficiario-repository";
import * as SolicitudRepository from "../../services/repositories/solicitud-repository";
import * as GeneralRepository from "../../services/repositories/general-repository";
import * as GeneralActions from "../../store/actions/generalActions";
import ModalValidacionPersonas from '../ModalValidacionPersonas/ModalValidacionPersonas'

const BeneficiarioModal = ({ mostrar, setMostrar, codTipoBeneficiario, state, setState, recargarLista, listaState }) => {
    const initialState = {
        estaCargando: {
            documentos: false,
            parentescos: false
        },
        deshabilitados: {
            parentescos: true
        },
        combos: {
            parentescos: []
        }
    }

    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]

    const [documentos, setDocumentos] = useState([])
    const [parentescos, setParentescos] = useState([])
    const [ edadFU, setEdadFU] = useState(0)

    const [stateLocal, setStateLocal] = useState(initialState)
    let fechaPrueba = (state.beneficiarioSeleccionado !== null ? (state.beneficiarioSeleccionado.fechaNacimiento || '') : '') //CORRECCION DE VALIDACION FEC NAC 
    const [inputDate, setInputDate] = useState(fechaPrueba)

    const [mostrarModal, setModal] = useState(false)
    const [textos, setTextos] = useState([])

    const [mostrarModal2, setModal2] = useState(false)
    const textos2 = [
        '¡Alerta!',
        'No se ubica el nro. de documento en la BD de Personas'
    ]

    const [tamanioDoc, setTamanioDoc] = useState(
        {
            estado: true,
            descripcion: ''
        }
    )

    const [mostrarPersonas, setMostrarPersonas] = useState(false)

    useEffect(() => {
        if (fechaPrueba !== '') {
            const fecha = new Date(state.beneficiarioSeleccionado.fechaNacimiento)
            if (state.beneficiarioSeleccionado.fechaNacimiento.constructor.name === 'String' && state.beneficiarioSeleccionado.fechaNacimiento.indexOf('-') > -1) {
                let fec = state.beneficiarioSeleccionado.fechaNacimiento.split('-')
                setInputDate({
                    day: fec[2],
                    month: fec[1],
                    year: fec[0]
                })
            } else {
                setInputDate({
                    day: fecha.getDate(),
                    month: fecha.getMonth(),
                    year: fecha.getFullYear()
                })
            }
        } else {
            setInputDate('')
        }
        setDocumentos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 13))
        setParentescos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 36))
        setEdadFU(Funciones.obtenerParametro(generalState.parametros, Constantes.COD_PARAMETRO_EDAD_MAXIMA_FU, Constantes.TIPO_DATO_NUMERICO))

        if (state.beneficiarioSeleccionado !== null && state.beneficiarioSeleccionado !== undefined) {
            if (state.beneficiarioSeleccionado.sexo !== undefined && state.beneficiarioSeleccionado.sexo.codigo !== undefined && state.beneficiarioSeleccionado.sexo.codigo !== null &&
                state.beneficiarioSeleccionado.sexo.codigo !== -1 && state.beneficiarioSeleccionado.sexo.codigo !== 0) {
                let sexoVal = state.beneficiarioSeleccionado.sexo.codigo
                let listaParentescos = parentescos.filter(parentesco => parentesco.codigoSexo.toString() === sexoVal.toString() ||
                    parentesco.codigoSexo.toString() === '2')
                setStateLocal((stateLocal) => {
                    return {
                        ...stateLocal,
                        deshabilitados: {
                            ...stateLocal.deshabilitados,
                            parentescos: false
                        },
                        combos: {
                            ...stateLocal.combos,
                            parentescos: listaParentescos
                        }
                    }
                })
            }
        }

    }, [fechaPrueba]) //CORRECCION DE VALIDACION FEC NAC

    useEffect(() => {
        if(codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_UNICO) {
            let listaParentescos = parentescos.filter(parentesco =>
                (state.beneficiarioSeleccionado !== null && state.beneficiarioSeleccionado.sexo !== undefined && 
                    parentesco.codigoSexo.toString() === state.beneficiarioSeleccionado.sexo.codigo.toString()) ||
                parentesco.codigoSexo.toString() === '2')
            listaParentescos = listaParentescos.filter(parentesco => parentesco.aplicaFondoUniversitario === true)
            setStateLocal({
                ...stateLocal,
                combos: {
                    ...state.combos,
                    parentescos: listaParentescos
                }
            })
        }
    }, [ state.beneficiarioSeleccionado ])

    const onChangeInputDate = (valor) => {
        setInputDate(valor)
        handleChangeFecha(valor, 'fechaNacimiento')
    }

    const handleCerrarModal = () => {
        setStateLocal((stateLocal) => {
            return {
                ...stateLocal,
                deshabilitados: {
                    ...stateLocal.deshabilitados,
                    parentescos: true
                }
            }
        })

        setState((state) => {
            return {
                ...state,
                beneficiarioSeleccionado: null,
                campoValidado: {
                    tipoDocumento: true,
                    numeroDocumento: true,
                    nombres: true,
                    apellidoPaterno: true,
                    apellidoMaterno: true,
                    parentesco: true,
                    fechaNacimiento: true,
                    sexo: true,
                    porcentajeBeneficio: true
                },
                modalInsertar: false
            }
        })
        setMostrar(false)
    }

    const handleChangeComboCustom = (event, campo) => {
        const codigo = event.target.value
        const descripcion = event.target[event.target.selectedIndex].text
        if (campo === 'tipoDocumento') {
            const tipoDocumento = {
                codigo: parseInt(codigo),
                descripcion: descripcion
            }

            setState((state) => {
                return {
                    ...state,
                    beneficiarioSeleccionado: {
                        ...state.beneficiarioSeleccionado,
                        [campo]: codigo === '-1' ? undefined : tipoDocumento,
                        numeroDocumento: '' // Limpiar numero documento al cambiar el tipo documento
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: true
                    }
                }
            })
        } else if (campo === 'parentesco') {
            setState((state) => {
                return {
                    ...state,
                    beneficiarioSeleccionado: {
                        ...state.beneficiarioSeleccionado,
                        [campo]: {
                            codigo: parseInt(codigo),
                            descripcion: descripcion
                        }
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: true
                    }
                }
            })
        }
    }

    const handleNumeroDocumento = (event, campo) => {
        //const { beneficiarioSeleccionado } = state
        //const { numeroDocumento, tipoDocumento } = beneficiarioSeleccionado

        let valor = ''

        if (state.beneficiarioSeleccionado != null && state.beneficiarioSeleccionado.numeroDocumento != null) {
            // Validar por tipo documento
            switch (state.beneficiarioSeleccionado.tipoDocumento.codigo) {
                case 1: //DNI
                    valor = event.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
                    break;
                case 2: //RUC
                    valor = event.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
                    break;
                case 3: //CE
                    valor = event.target.value.replace(/[^0-9A-Z]/gi, "")
                    valor = valor.toUpperCase()
                    break;
                case 4: //DNI Electronico
                    valor = event.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
                    break;
                case 5: //PASAPORTE
                    valor = event.target.value.replace(/[^(?!^0+$)[a-zA-Z0-9]{3,20}]/gi, "")
                    break;
                default:
                    console.error('No existe un Tipo de documento válido');
            }
        }

        setState((state) => {
            return {
                ...state,
                beneficiarioSeleccionado: {
                    ...state.beneficiarioSeleccionado,
                    [campo]: valor
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeTexto = (event, campo) => {
        let valor = event.target.value.replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, "")
        let capital = Funciones.mostrarCamelCase(valor)
        setState((state) => {
            return {
                ...state,
                beneficiarioSeleccionado: {
                    ...state.beneficiarioSeleccionado,
                    [campo]: capital,
                    indicadorModificacionDatosPID: state.beneficiarioSeleccionado === null ? '0' : state.beneficiarioSeleccionado.indicadorModificacionDatosPID === '1'
                        ? '2' : state.beneficiarioSeleccionado.indicadorModificacionDatosPID
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeFecha = (event, campo) => {
        let valor = event
        setState((state) => {
            return {
                ...state,
                beneficiarioSeleccionado: {
                    ...state.beneficiarioSeleccionado,
                    [campo]: Funciones.transformarDatePickerToFecha(valor),
                    indicadorModificacionDatosPID: state.beneficiarioSeleccionado === null ? '0' : state.beneficiarioSeleccionado.indicadorModificacionDatosPID === '1'
                        ? '2' : state.beneficiarioSeleccionado.indicadorModificacionDatosPID
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeSexo = (event) => {
        const sexoVal = event.target.value
        let listaParentescos = parentescos.filter(parentesco => parentesco.codigoSexo.toString() === sexoVal.toString() ||
            parentesco.codigoSexo.toString() === '2')
        
        if(codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_UNICO) {
            listaParentescos = listaParentescos.filter(parentesco => parentesco.aplicaFondoUniversitario === true)
        }

        setStateLocal((stateLocal) => {
            return {
                ...stateLocal,
                deshabilitados: {
                    ...stateLocal.deshabilitados,
                    parentescos: false
                },
                combos: {
                    ...stateLocal.combos,
                    parentescos: listaParentescos
                }
            }
        })

        setState((state) => {
            return {
                ...state,
                beneficiarioSeleccionado: {
                    ...state.beneficiarioSeleccionado,
                    sexo: {
                        codigo: parseInt(sexoVal)
                    },
                    indicadorModificacionDatosPID: state.beneficiarioSeleccionado === null ? '0' : state.beneficiarioSeleccionado.indicadorModificacionDatosPID === '1'
                        ? '2' : state.beneficiarioSeleccionado.indicadorModificacionDatosPID
                },
                campoValidado: {
                    ...state.campoValidado,
                    sexo: true
                }
            }
        })
    }

    const handleChangePorcentaje = (e, campo) => {
        let valor = e.target.value
        setState((state) => {
            return {
                ...state,
                beneficiarioSeleccionado: {
                    ...state.beneficiarioSeleccionado,
                    [campo]: valor
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const longitud = (e) => {
        let valor = e.target.value
        if (valor.indexOf(".") === 1) {
            if (e.target.value.length > 4) {
                e.target.value = e.target.value.slice(0, 4)
            }
        } else if (valor.indexOf(".") === 2) {
            if (e.target.value.length > 5) {
                e.target.value = e.target.value.slice(0, 5)
            }
        } else if (valor.indexOf(".") === 3) {
            if (e.target.value.length > 6) {
                e.target.value = e.target.value.slice(0, 6)
            }
        } else {
            if (e.target.value.length > 3) {
                e.target.value = e.target.value.slice(0, 3)
            }
        }
    }

    const handleBlurPersonID = async () => {
        const buscarPersonID = async () => {
            setState((state) => {
                return {
                    ...state,
                    campoValidado: {
                        ...state.campoValidado,
                        numeroDocumento: true
                    }
                }
            })

            if (state.beneficiarioSeleccionado !== null) {
                const response = await GeneralRepository.obtenerValidacionPersonas(state.beneficiarioSeleccionado.tipoDocumento.codigo, 
                    state.beneficiarioSeleccionado.numeroDocumento)
                if (response.error === null) {
                    if (response.personas.length === 1) {
                        let persona = response.personas[0]
                        let beneficiarioSeleccionado = {
                            ...state.beneficiarioSeleccionado,
                            nombres: Funciones.mostrarCamelCase(persona.nombres),
                            apellidoPaterno: Funciones.mostrarCamelCase(persona.apellidoPaterno),
                            apellidoMaterno: Funciones.mostrarCamelCase(persona.apellidoMaterno),
                            fechaNacimiento: Funciones.formatearTextoAFecha(persona.fechaNacimiento), //nueva funcion para convertir fecha de personID
                            sexo: {
                                codigo: persona.sexo === 'F' ? 0 : persona.sexo === 'M' ? 1 : null
                            },
                            indicadorModificacionDatosPID: '1'
                        }
    
                        setState((state) => {
                            return {
                                ...state,
                                estaCargando: false,
                                beneficiarioSeleccionado: beneficiarioSeleccionado,
                                campoValidado: {
                                    ...state.campoValidado,
                                    nombres: true,
                                    apellidoPaterno: true,
                                    apellidoMaterno: true,
                                    sexo: true,
                                    fechaNacimiento: true
                                }
                            }
                        })
    
                        let listaParentescos = parentescos.filter(parentesco =>
                            parentesco.codigoSexo.toString() === beneficiarioSeleccionado.sexo.codigo.toString() ||
                            parentesco.codigoSexo.toString() === '2')
                        setStateLocal((stateLocal) => {
                            return {
                                ...stateLocal,
                                deshabilitados: {
                                    ...stateLocal.deshabilitados,
                                    parentescos: false
                                },
                                combos: {
                                    ...stateLocal.combos,
                                    parentescos: listaParentescos
                                }
                            }
                        })
                    } else if (response.personas.length === 2) {
                        let viap = response.personas.find(p => p.origen === 'viap')
                        let personID = response.personas.find(p => p.origen === 'personid')
                    
                        setState((state) => {
                            return {
                                ...state,
                                viap: viap,
                                personID: personID
                            }
                        })
                        setMostrarPersonas(true)
                    } else {
                        generalDispatch(GeneralActions.updateError(
                            {mensajeRespuesta: 'El identificador de personas no identificó ningún dato para el documento consultado'}, '¡Mensaje!')
                        )
                        setState((state) => {
                            return {
                                ...state,
                                beneficiarioSeleccionado: {
                                    numeroDocumento: state.beneficiarioSeleccionado.numeroDocumento,
                                    tipoDocumento: state.beneficiarioSeleccionado.tipoDocumento,
                                    indicadorModificacionDatosPID: '3'
                                }
                            }
                        })
                    }
                } else {
                    if (state.beneficiarioSeleccionado.idBeneficiario !== undefined &&
                        state.beneficiarioSeleccionado.idBeneficiario !== null) {
                        setState((state) => {
                            return {
                                ...state,
                                beneficiarioSeleccionado: {
                                    ...state.beneficiarioSeleccionado,
                                    indicadorModificacionDatosPID: '3'
                                }
                            }
                        })
                    } else {
                        setState((state) => {
                            return {
                                ...state,
                                beneficiarioSeleccionado: {
                                    numeroDocumento: state.beneficiarioSeleccionado.numeroDocumento,
                                    tipoDocumento: state.beneficiarioSeleccionado.tipoDocumento,
                                    indicadorModificacionDatosPID: '3'
                                }
                            }
                        })
                    }
                    generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
                }
            }
        }

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        if (state.beneficiarioSeleccionado !== null && state.beneficiarioSeleccionado.tipoDocumento && state.beneficiarioSeleccionado.tipoDocumento.codigo !== undefined &&
            state.beneficiarioSeleccionado.tipoDocumento.codigo !== null && state.beneficiarioSeleccionado.tipoDocumento.codigo !== -1 &&
            state.beneficiarioSeleccionado.tipoDocumento.codigo !== 0 && state.beneficiarioSeleccionado.numeroDocumento) {
            if (state.beneficiarioSeleccionado.tipoDocumento.codigo === 1 || state.beneficiarioSeleccionado.tipoDocumento.codigo === 4) {
                if (state.beneficiarioSeleccionado.numeroDocumento.length < 8) {
                    setTamanioDoc({
                        estado: false,
                        descripcion: 'La longitud no debe ser menor que 8.'
                    })
                } else {
                    setTamanioDoc({
                        estado: true,
                        descripcion: ''
                    })
                    await buscarPersonID()
                }
            } else if (state.beneficiarioSeleccionado.tipoDocumento.codigo === 3) {
                if (state.beneficiarioSeleccionado.numeroDocumento.length < 3) {
                    setTamanioDoc({
                        estado: false,
                        descripcion: 'La longitud debe estar entre 3 y 12.'
                    })
                } else {
                    setTamanioDoc({
                        estado: true,
                        descripcion: ''
                    })
                    await buscarPersonID()
                }
            }
        }
        generalDispatch(GeneralActions.updateEstadoCargando(false))
    }

    const personaSeleccionada = (valor) => {
        let persona = valor === 1 ? state.personID : state.viap
        let beneficiarioSeleccionado = {
            ...state.beneficiarioSeleccionado,
            nombres: Funciones.mostrarCamelCase(persona.nombres),
            apellidoPaterno: Funciones.mostrarCamelCase(persona.apellidoPaterno),
            apellidoMaterno: Funciones.mostrarCamelCase(persona.apellidoMaterno),
            fechaNacimiento: Funciones.formatearTextoAFecha(persona.fechaNacimiento), //nueva funcion para convertir fecha de personID
            sexo: {
                codigo: persona.sexo === 'F' ? 0 : persona.sexo === 'M' ? 1 : null
            },
            indicadorModificacionDatosPID: '1'
        }

        setState((state) => {
            return {
                ...state,
                estaCargando: false,
                beneficiarioSeleccionado: beneficiarioSeleccionado,
                campoValidado: {
                    ...state.campoValidado,
                    nombres: true,
                    apellidoPaterno: true,
                    apellidoMaterno: true,
                    sexo: true,
                    fechaNacimiento: true
                }
            }
        })

        let listaParentescos = parentescos.filter(parentesco =>
            parentesco.codigoSexo.toString() === beneficiarioSeleccionado.sexo.codigo.toString() ||
            parentesco.codigoSexo.toString() === '2')
        setStateLocal((stateLocal) => {
            return {
                ...stateLocal,
                deshabilitados: {
                    ...stateLocal.deshabilitados,
                    parentescos: false
                },
                combos: {
                    ...stateLocal.combos,
                    parentescos: listaParentescos
                }
            }
        })

        setMostrarPersonas(false)
    }


    const handleEnviarBeneficiario = async () => {
        const invocarPostBeneficiario = async (producto) => {
            let beneficiarioAux = {
                ...state.beneficiarioSeleccionado,
                tipoBeneficiario: {
                    codigo: codTipoBeneficiario
                },
                porcentajeBeneficio: state.beneficiarioSeleccionado.porcentajeBeneficio !== null
                    && state.beneficiarioSeleccionado.porcentajeBeneficio !== undefined
                    ? Number(state.beneficiarioSeleccionado.porcentajeBeneficio)
                    : 100,
                indicadorModificacionDatosPID: state.beneficiarioSeleccionado.indicadorModificacionDatosPID
            }

            const response = await BeneficiarioRepository.guardarBeneficiario(producto.idSolicitud, beneficiarioAux, user.info.IdUsuario)
            if (response.error === null) {
                setState((state) => {
                    return {
                        ...state,
                        estaCargando: false,
                        beneficiarioSeleccionado: null,
                        mostrarApoderado: codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_UNICO
                    }
                })
                setMostrar(false)
                updateBeneficiaryMultiple(producto);
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            }
        }

        const invocarPutBeneficiario = async (idBeneficiario, idSolicitud) => {
            let beneficiarioAux = null
            let idSolicitudEnviar = idSolicitud

            if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO) {
                beneficiarioAux = {
                    ...state.beneficiarioUnico,
                    idBeneficiario: state.beneficiarioUnico.idBeneficiario,
                    tutor: {
                        ...state.beneficiarioSeleccionado,
                        indicadorModificacionDatosPID: state.beneficiarioSeleccionado.indicadorModificacionDatosPID === undefined ?
                            '0' : state.beneficiarioSeleccionado.indicadorModificacionDatosPID
                    }
                }
                idSolicitudEnviar = state.beneficiarioUnico.idSolicitud
            } else {
                beneficiarioAux = {
                    ...state.beneficiarioSeleccionado,
                    tipoBeneficiario: {
                        codigo: codTipoBeneficiario
                    },
                    idBeneficiario: idBeneficiario,
                    porcentajeBeneficio: Number(state.beneficiarioSeleccionado.porcentajeBeneficio),
                    indicadorModificacionDatosPID: state.beneficiarioSeleccionado.indicadorModificacionDatosPID
                }
            }

            const response = await BeneficiarioRepository.guardarBeneficiario(idSolicitudEnviar, beneficiarioAux, user.info.IdUsuario)
            if (response.error === null) {
                setState((state) => {
                    return {
                        ...state,
                        estaCargando: false,
                        beneficiarioSeleccionado: null
                    }
                })

                setMostrar(false)
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            }
        }
        
        const updateBeneficiaryMultiple = async (producto) => {
            let solicitud = {
                beneficiarioMultiple: state.beneficiarioMultiple,
                idSolicitud: producto.idSolicitud,
                indicadorAseguradoCobraBeneficio: state.indicadorAseguradoCobraBeneficio
            }
            const response = await SolicitudRepository.actualizarSolicitud(state.solicitudes.idSolicitudMultiple, state.solicitudes.marcaLpdp, state.solicitudes.marcaAdicionalLpdp, solicitud)
            if (response.error === null) {
                return true
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡!Alerta'))
                return false
            }
        }

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        if (state.beneficiarioSeleccionado !== null &&
            state.beneficiarioSeleccionado.idBeneficiario !== undefined &&
            state.beneficiarioSeleccionado.idBeneficiario !== null) {
            //Actualizar
            if (state.tipoCaso === Constantes.TIPO_CASO_1) {
                if (state.beneficiarioMultiple) {
                    let index = 0
                    for (const idBeneficiario of state.beneficiarioSeleccionado.idBeneficiarioArray) {
                        await invocarPutBeneficiario(idBeneficiario, state.beneficiarioSeleccionado.idSolicitudArray[index])
                        index++
                    }
                } else {
                    let index = 0
                    for (const idBeneficiario of state.beneficiarioSeleccionado.idBeneficiarioArray) {
                        switch (codTipoBeneficiario) {
                            case Constantes.COD_TIPO_BENEFICIARIO_UNICO: {
                                await invocarPutBeneficiario(idBeneficiario, state.beneficiarioSeleccionado.idSolicitudArray[index])
                                break
                            }
                            case Constantes.COD_TIPO_BENEFICIARIO_APODERADO: {
                                await invocarPutBeneficiario(null, null)
                                break
                            }
                            default: {
                                break
                            }
                        }
                        index++
                    }
                }
            } else if (state.tipoCaso === Constantes.TIPO_CASO_2) {
                let index = 0
                for (const idBeneficiario of state.beneficiarioSeleccionado.idBeneficiarioArray) {
                    await invocarPutBeneficiario(idBeneficiario, state.beneficiarioSeleccionado.idSolicitudArray[index])
                    index++
                }
            } else if (state.tipoCaso === Constantes.TIPO_CASO_3) {
                if (state.beneficiarioMultiple) {
                    let index = 0
                    for (const idBeneficiario of state.beneficiarioSeleccionado.idBeneficiarioArray) {
                        await invocarPutBeneficiario(idBeneficiario, state.beneficiarioSeleccionado.idSolicitudArray[index])
                        index++
                    }
                } else {
                    let index = 0
                    for (const idBeneficiario of state.beneficiarioSeleccionado.idBeneficiarioArray) {
                        switch (codTipoBeneficiario) {
                            case Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL: {
                                await invocarPutBeneficiario(idBeneficiario, state.beneficiarioSeleccionado.idSolicitudArray[index])
                                break
                            }
                            case Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE: {
                                await invocarPutBeneficiario(idBeneficiario, state.beneficiarioSeleccionado.idSolicitudArray[index])
                                break
                            }
                            case Constantes.COD_TIPO_BENEFICIARIO_UNICO: {
                                await invocarPutBeneficiario(idBeneficiario, state.beneficiarioSeleccionado.idSolicitudArray[index])
                                break
                            }
                            case Constantes.COD_TIPO_BENEFICIARIO_APODERADO: {
                                await invocarPutBeneficiario(idBeneficiario, state.beneficiarioSeleccionado.idSolicitudArray[index])
                                break
                            }
                            default: {
                                break
                            }
                        }
                        index++
                    }
                }
            }
            await recargarLista();
        } else {
            //Registrar
            if (state.tipoCaso === Constantes.TIPO_CASO_1) {
                if (state.beneficiarioMultiple) {
                    for (const producto of state.solicitudes.productos) {
                        await invocarPostBeneficiario(producto)
                    }
                } else {
                    for (const producto of state.solicitudes.productos) {
                        switch (codTipoBeneficiario) {
                            case Constantes.COD_TIPO_BENEFICIARIO_UNICO: {
                                if (producto.codigoTipoProducto === Constantes.COD_TIPO_PRODUCTO_FONDO_UNIVERSITARIO) {
                                    await invocarPostBeneficiario(producto)
                                }
                                break
                            }
                            case Constantes.COD_TIPO_BENEFICIARIO_APODERADO: {
                                if (producto.codigoTipoProducto === Constantes.COD_TIPO_PRODUCTO_FONDO_UNIVERSITARIO) {
                                    await invocarPutBeneficiario(null, null)
                                }
                                break
                            }
                            default: {
                                break
                            }
                        }
                    }
                }
            } else if (state.tipoCaso === Constantes.TIPO_CASO_2) {
                for (const producto of state.solicitudes.productos) {
                    await invocarPostBeneficiario(producto)
                }
            } else if (state.tipoCaso === Constantes.TIPO_CASO_3) {
                if (state.beneficiarioMultiple) {
                    for (const producto of state.solicitudes.productos) {
                        await invocarPostBeneficiario(producto);
                    }
                } else {
                    for (const producto of state.solicitudes.productos) {
                        switch (codTipoBeneficiario) {
                            case Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL: {
                                if (producto.codigoTipoProducto !== Constantes.COD_TIPO_PRODUCTO_FONDO_UNIVERSITARIO) {
                                    await invocarPostBeneficiario(producto)
                                }
                                break
                            }
                            case Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE: {
                                if (producto.codigoTipoProducto !== Constantes.COD_TIPO_PRODUCTO_FONDO_UNIVERSITARIO) {
                                    await invocarPostBeneficiario(producto)
                                }
                                break
                            }
                            case Constantes.COD_TIPO_BENEFICIARIO_UNICO: {
                                if (producto.codigoTipoProducto === Constantes.COD_TIPO_PRODUCTO_FONDO_UNIVERSITARIO) {
                                    await invocarPostBeneficiario(producto)
                                }
                                break
                            }
                            case Constantes.COD_TIPO_BENEFICIARIO_APODERADO: {
                                if (producto.codigoTipoProducto === Constantes.COD_TIPO_PRODUCTO_FONDO_UNIVERSITARIO) {
                                    await invocarPutBeneficiario(producto, 0)
                                }
                                break
                            }
                            default: {
                                break
                            }
                        }
                    }
                }
            }
            await recargarLista();
        }
        generalDispatch(GeneralActions.updateEstadoCargando(false))
    }

    const obtenerTamanoNumDocumento = (objeto, campoRelacion, campo) => {
        if (objeto !== null && objeto[campoRelacion] !== undefined) {
            return Constantes['CANTIDAD_DIGITOS_TIPO_DOCUMENTO_' + objeto[campoRelacion].codigo]
        } else {
            return '0'
        }
    }

    const mostrarPopup = () => {
        setModal(!mostrarModal)
    }

    const validarFormulario = () => {
        let validado = true
        const asignarValidacionCampo = (campo, valor) => {
            validado = validado && valor
            setState((state) => {
                return {
                    ...state,
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: valor
                    }
                }
            })
        }

        const validarTexto = (objeto, campoValidacion, campo) => {
            if (objeto === null || objeto[campo] === undefined ||
                objeto[campo] === '') {
                asignarValidacionCampo(campoValidacion, false)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarCombo = (objeto, campoValidacion, campo) => {
            if (objeto === null || objeto[campo] === null ||
                objeto[campo] === undefined ||
                objeto[campo].codigo === null ||
                objeto[campo].codigo === -1) {
                asignarValidacionCampo(campoValidacion, false)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarFecha = (objeto, campoValidacion, campo) => {
            if (objeto === null || objeto[campo] === undefined ||
                objeto[campo] === '') {
                asignarValidacionCampo(campoValidacion, false)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarPorcentaje = (objeto, campoValidacion, campo, porcentajeMaximo) => {
            if (objeto === null ||
                objeto[campo] === null ||
                objeto[campo] === undefined ||
                objeto[campo] === '' ||
                objeto[campo] === '0' ||
                Number(objeto[campo]) > porcentajeMaximo + listaState.porcentajeEdicion) {
                asignarValidacionCampo(campoValidacion, false)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarNumeroDocumento = (objeto, campoValidacion, campoRelacion, campo) => {
            if (objeto === null
                || objeto[campo] === ''
                || objeto[campo] === undefined) {
                asignarValidacionCampo(campoValidacion, false)
            } else {
                if (objeto != null && objeto[campoRelacion] !== undefined &&
                    (objeto[campoRelacion].codigo === 1 || objeto[campoRelacion].codigo === 4)) {
                    if (objeto == null
                        || objeto[campo] === ''
                        || objeto[campo] === undefined
                        || objeto[campo].match(/[01]{8,}/)
                        || objeto[campo].match(/12345678.*/)) {
                        asignarValidacionCampo(campoValidacion, false)
                    } else {
                        asignarValidacionCampo(campoValidacion, true)
                    }
                } else if (objeto != null && objeto[campoRelacion] !== undefined &&
                    objeto[campoRelacion].codigo === 2) {
                    if (objeto == null
                        || objeto[campo] === ''
                        || objeto[campo] === undefined
                        || objeto[campo].match(/[01]{11,}/)) {
                        asignarValidacionCampo(campoValidacion, false)
                    } else {
                        asignarValidacionCampo(campoValidacion, true)
                    }
                } else if (objeto != null && objeto[campoRelacion] !== undefined &&
                    objeto[campoRelacion].codigo === 3) {
                    if (objeto == null
                        || objeto[campo] === ''
                        || objeto[campo] === undefined
                        || objeto[campo].match(/[01]{6,12}/)) {
                        asignarValidacionCampo(campoValidacion, false)
                    } else {
                        asignarValidacionCampo(campoValidacion, true)
                    }
                }
            }
        }

        const validarExistenciaBeneficiario = () => {
            let listaBeneficiarios = null
            let existeBeneficiario = false

            if (state.beneficiarioSeleccionado && (state.beneficiarioSeleccionado.idBeneficiario === null || state.beneficiarioSeleccionado.idBeneficiario === undefined)) {
                if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL) {
                    listaBeneficiarios = state.beneficiariosPrincipales
                } else if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE) {
                    listaBeneficiarios = state.beneficiariosContingentes
                } else if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO) {
                    if (state.beneficiarioSeleccionado.tipoDocumento.codigo === state.beneficiarioUnico.tipoDocumento.codigo &&
                        state.beneficiarioSeleccionado.numeroDocumento === state.beneficiarioUnico.numeroDocumento) {
                            setTextos(['Importante', 'El apoderado no debe ser igual al beneficiario único.'])
                            existeBeneficiario = true
                    }
                }

                if (listaBeneficiarios !== null) {
                    listaBeneficiarios.map(beneficiario => {
                        if (beneficiario.tipoDocumento.codigo === null && beneficiario.numeroDocumento === Constantes.CADENA_VACIA) {
                            if ((beneficiario.nombres !== undefined && state.beneficiarioSeleccionado.nombres !== undefined &&
                                beneficiario.nombres.trim() === state.beneficiarioSeleccionado.nombres.trim()) &&
                                (beneficiario.apellidoPaterno !== undefined && state.beneficiarioSeleccionado.apellidoPaterno !== undefined &&
                                beneficiario.apellidoPaterno === state.beneficiarioSeleccionado.apellidoPaterno) &&
                                (beneficiario.apellidoMaterno !== undefined && state.beneficiarioSeleccionado.apellidoMaterno !== undefined &&
                                beneficiario.apellidoMaterno === state.beneficiarioSeleccionado.apellidoMaterno)) {
                                    setTextos(['Importante',
                                        'El beneficiario ya se encuentra registrado.'
                                    ])
                                    existeBeneficiario = true
                            }
                        } else {
                            if ((state.beneficiarioSeleccionado.tipoDocumento !== undefined && beneficiario.tipoDocumento.codigo === state.beneficiarioSeleccionado.tipoDocumento.codigo) &&
                            beneficiario.numeroDocumento === state.beneficiarioSeleccionado.numeroDocumento) {
                                setTextos(['Importante',
                                        'El beneficiario ya se encuentra registrado.'
                                    ])
                                existeBeneficiario = true
                            }
                        }
                        return beneficiario
                    })

                    if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL) {
                        if (state.beneficiariosContingentes !== null) {
                            state.beneficiariosContingentes.map(beneficiario => {
                                if (((beneficiario.tipoDocumento.codigo === 0 && state.beneficiarioSeleccionado.tipoDocumento === undefined) ||
                                    (state.beneficiarioSeleccionado.tipoDocumento !== undefined && state.beneficiarioSeleccionado.tipoDocumento.codigo !== -1 &&
                                        beneficiario.tipoDocumento.codigo === state.beneficiarioSeleccionado.tipoDocumento.codigo)) &&
                                    ((beneficiario.numeroDocumento === Constantes.CADENA_VACIA && state.beneficiarioSeleccionado.numeroDocumento === undefined) ||
                                    (beneficiario.numeroDocumento === state.beneficiarioSeleccionado.numeroDocumento))) {
                                            setTextos(['Importante',
                                                'Ya se registró un beneficiario con el mismo número de documento.'
                                            ])
                                    existeBeneficiario = true
                                }
                                return beneficiario
                            })
                        }
                    }

                    if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE) {
                        if (state.beneficiariosPrincipales !== null) {
                            state.beneficiariosPrincipales.map(beneficiario => {
                                /*if (((beneficiario.tipoDocumento.codigo === 0 && state.beneficiarioSeleccionado.tipoDocumento === undefined) ||
                                    (state.beneficiarioSeleccionado.tipoDocumento !== undefined &&
                                        beneficiario.tipoDocumento.codigo === state.beneficiarioSeleccionado.tipoDocumento.codigo)) &&
                                    ((beneficiario.numeroDocumento === Constantes.CADENA_VACIA && state.beneficiarioSeleccionado.numeroDocumento === undefined) ||
                                    (beneficiario.numeroDocumento === state.beneficiarioSeleccionado.numeroDocumento))) {
                                            setTextos(['Importante',
                                                'Ya se registró un beneficiario con el mismo número de documento.'
                                            ])
                                    existeBeneficiario = true
                                }
                                return beneficiario*/
                                if (beneficiario.tipoDocumento.codigo === null && beneficiario.numeroDocumento === Constantes.CADENA_VACIA) {
                                    if ((beneficiario.nombres !== undefined && state.beneficiarioSeleccionado.nombres !== undefined &&
                                        beneficiario.nombres.trim() === state.beneficiarioSeleccionado.nombres.trim()) &&
                                        (beneficiario.apellidoPaterno !== undefined && state.beneficiarioSeleccionado.apellidoPaterno !== undefined &&
                                        beneficiario.apellidoPaterno === state.beneficiarioSeleccionado.apellidoPaterno) &&
                                        (beneficiario.apellidoMaterno !== undefined && state.beneficiarioSeleccionado.apellidoMaterno !== undefined &&
                                        beneficiario.apellidoMaterno === state.beneficiarioSeleccionado.apellidoMaterno)) {
                                            setTextos(['Importante',
                                                'El beneficiario ya se encuentra registrado.'
                                            ])
                                            existeBeneficiario = true
                                    }
                                } else {
                                    if ((state.beneficiarioSeleccionado.tipoDocumento !== undefined && state.beneficiarioSeleccionado.tipoDocumento.codigo !== -1 &&
                                        beneficiario.tipoDocumento.codigo === state.beneficiarioSeleccionado.tipoDocumento.codigo) &&
                                        beneficiario.numeroDocumento === state.beneficiarioSeleccionado.numeroDocumento) {
                                            setTextos(['Importante',
                                                    'Ya se registró un beneficiario con el mismo número de documento.'
                                                ])
                                            existeBeneficiario = true
                                    }
                                }
                                return beneficiario
                            })
                        }
                    }
                }

                if (existeBeneficiario) {
                    mostrarPopup()
                    validado = false
                }
            }
        }

        const validarCasosBeneficiario = () => {
            //Caso 1: Beneficiario igual a Asegurado
            if((codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL || codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE) &&
                state.beneficiarioSeleccionado.tipoDocumento !== undefined &&
                state.beneficiarioSeleccionado.tipoDocumento.codigo === state.asegurado.tipoDocumento.codigo &&
                state.beneficiarioSeleccionado.numeroDocumento === state.asegurado.numeroDocumento) {
                    setTextos(['Importante', 'El beneficiario debe ser diferente al asegurado.'])
                    validado = false
            } else {
                if (state.beneficiarioSeleccionado.fechaNacimiento !== undefined) {
                    if (codTipoBeneficiario !== Constantes.COD_TIPO_BENEFICIARIO_APODERADO) {
                        let fechaBeneficiario = new Date(Funciones.formatearTextoAFecha(state.beneficiarioSeleccionado.fechaNacimiento))//Funciones.formatearTextoAFecha(state.beneficiarioSeleccionado.fechaNacimiento))
                        let fechaAsegurado = new Date(state.asegurado.fechaNacimiento)

                        if((state.beneficiarioSeleccionado.parentesco.codigo === 2 || state.beneficiarioSeleccionado.parentesco.codigo === 3) &&
                            fechaBeneficiario <= fechaAsegurado) {
                                //Caso 2: Beneficiario hijo menor que Asegurado
                                setTextos([
                                    'Importante',
                                    'Edad ' + (state.beneficiarioSeleccionado.sexo.codigo === 0 ? 'de la hija' : 'del hijo') + ' no debe ser mayor o igual a la edad del asegurado.'])
                                validado = false
                        } else {
                            if((state.beneficiarioSeleccionado.parentesco.codigo === 4 || state.beneficiarioSeleccionado.parentesco.codigo === 5) &&
                                fechaBeneficiario >= fechaAsegurado) {
                                    //Caso 3: Beneficiario padre mayor que Asegurado
                                    setTextos([
                                        'Importante',
                                        'Edad ' + (state.beneficiarioSeleccionado.sexo.codigo === 0 ? 'de la m' : 'del p') + 'adre no debe ser menor o igual a la edad del asegurado.'])
                                    validado = false
                            }
                        }
                    }
                    if(codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO) {
                        const fechaBeneficiario = new Date(Funciones.formatearTextoAFecha(state.beneficiarioSeleccionado.fechaNacimiento));
                        const fechaActual = new Date();
                        const fechaMinima = new Date(fechaActual.getFullYear() - 18, fechaActual.getMonth(), fechaActual.getDate());
                        if (fechaBeneficiario > fechaMinima) {
                            setTextos(['Importante', 'El apoderado debe ser mayor de edad.']);
                            validado = false;
                        }
                    }
                }
            }

            if (!validado) {
                mostrarPopup()
                validado = false
            }
        }

        /* CAMUNOZR INICIO - Tipo documento y numeroDocumento serán obligatorios para Beneficiario Unico */
        if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_UNICO) {
            validarCombo(state.beneficiarioSeleccionado, 'tipoDocumento', 'tipoDocumento')
            validarNumeroDocumento(state.beneficiarioSeleccionado, 'numeroDocumento', 'tipoDocumento', 'numeroDocumento')
        }
        /* CAMUNOZR FIN */
        /* CMUNAYLLA INICIO - Tipo documento será obligatorio para Apoderado */
        if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO) {
            validarCombo(state.beneficiarioSeleccionado, 'tipoDocumento', 'tipoDocumento')
        }
        /* CMUNAYLLA FIN */
        validarTexto(state.beneficiarioSeleccionado, 'nombres', 'nombres')
        validarTexto(state.beneficiarioSeleccionado, 'apellidoPaterno', 'apellidoPaterno')
        /* ADICIONAL 4 INICIO - validacion apellido Materno */
        if (state.beneficiarioSeleccionado === null || (state.beneficiarioSeleccionado && state.beneficiarioSeleccionado.tipoDocumento
            && state.beneficiarioSeleccionado.tipoDocumento.codigo !== 3)) {
            validarTexto(state.beneficiarioSeleccionado, 'apellidoMaterno', 'apellidoMaterno')
        } else {
            setState((state) => {
                return {
                    ...state,
                    campoValidado: {
                        ...state.campoValidado,
                        apellidoMaterno: true
                    }
                }
            })
        }
        /* ADICIONAL 4 FIN */
        validarCombo(state.beneficiarioSeleccionado, 'parentesco', 'parentesco')
        validarFecha(state.beneficiarioSeleccionado, 'fechaNacimiento', 'fechaNacimiento')
        validarCombo(state.beneficiarioSeleccionado, 'sexo', 'sexo')

        validarExistenciaBeneficiario()
        if (state.beneficiarioSeleccionado !== null && state.beneficiarioSeleccionado !== undefined)
            validarCasosBeneficiario()

        if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL ||
            codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE) {
                validarPorcentaje(state.beneficiarioSeleccionado, 'porcentajeBeneficio', 'porcentajeBeneficio', listaState.porcentajeFaltante)
        }

        if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO && edadExacta <= 14) {
            validado = false
        }

        //Invocar Servicio Post/Put Contratante
        if (validado) {
            return handleEnviarBeneficiario()
        } else {
            return false
        }
    }

    const calcularEdad = (fechaInicio, fechaFin) => {
        if(fechaInicio !== null) {
            const ms = fechaFin.getTime() - fechaInicio.getTime();
            const date = new Date(ms);
            return Math.abs(date.getUTCFullYear() - 1970);
        }
        return null
    }

    //calcular edad de beneficiarios 
    let nacimiento = state.beneficiarioSeleccionado !== null ? inputDate : null
    let hoy = new Date()
    let edad = parseInt(hoy.getFullYear())
    let fecNacimiento = nacimiento !== null ? new Date(nacimiento.year, nacimiento.month, nacimiento.day, 0, 0, 0) : null
    let edadBene = calcularEdad(fecNacimiento, hoy)
    let año = nacimiento !== null && nacimiento !== undefined ? nacimiento.year : null
    let edadActualApoderado = edad - año
    let mesesFechaActual = parseInt(hoy.getMonth())
    let mesesNacimiento = nacimiento !== null && nacimiento !== undefined ? nacimiento.month : null
    let diasActual = hoy.getDate()
    let obtenerFechaSeparadaPorDia = nacimiento !== null && nacimiento !== undefined ? nacimiento.day : null
    let cumpleaños = mesesNacimiento - 1 <= mesesFechaActual && diasActual >= obtenerFechaSeparadaPorDia ? 1 : 0
    let edadExacta = (edadActualApoderado - 1) + cumpleaños

    //validar BENEFICIARIOS SELECCIONADO
    let benefSeleccionado = state.beneficiarioSeleccionado !== null ? state.beneficiarioSeleccionado.idBeneficiario : null

    //INICIO-Utilitarios CampoFecha
    const myCustomLocale = {
        // months list by order
        months: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Setiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
        ],

        // week days by order
        weekDays: [
            {
                name: 'Domingo', // used for accessibility 
                short: 'D', // displayed at the top of days' rows
                isWeekend: true, // is it a formal weekend or not?
            },
            {
                name: 'Lunes',
                short: 'L',
            },
            {
                name: 'Martes',
                short: 'M',
            },
            {
                name: 'Miércoles',
                short: 'M',
            },
            {
                name: 'Jueves',
                short: 'J',
            },
            {
                name: 'Viernes',
                short: 'V',
            },
            {
                name: 'Sábado',
                short: 'S',
                isWeekend: true,
            }
        ],

        // just play around with this number between 0 and 6
        weekStartingIndex: 0,

        // return a { year: number, month: number, day: number } object
        getToday(gregorainTodayObject) {
            return gregorainTodayObject;
        },

        // return a native JavaScript date here
        toNativeDate(date) {
            return new Date(date.year, date.month - 1, date.day);
        },

        // return a number for date's month length
        getMonthLength(date) {
            return new Date(date.year, date.month, 0).getDate();
        },

        // return a transformed digit to your locale
        transformDigit(digit) {
            return digit;
        },

        // texts in the date picker
        nextMonth: 'Next Month',
        previousMonth: 'Previous Month',
        openMonthSelector: 'Open Month Selector',
        openYearSelector: 'Open Year Selector',
        closeMonthSelector: 'Close Month Selector',
        closeYearSelector: 'Close Year Selector',
        defaultPlaceholder: 'Select...',

        // for input range value
        from: 'from',
        to: 'to',
        // used for input value when multi dates are selected
        digitSeparator: ',',

        // if your provide -2 for example, year will be 2 digited
        yearLetterSkip: 0,

        // is your language rtl or ltr?
        isRtl: false,
    }

    const obtenerFormatoFecha = () => {
        const valor = (state.beneficiarioSeleccionado !== null && state.beneficiarioSeleccionado.fechaNacimiento) ?
            Funciones.transformarFechaToDatePicker(state.beneficiarioSeleccionado.fechaNacimiento) : ''
        if (!valor) return ''
        return `${valor.day}/${valor.month}/${valor.year}`
    }
    //FIN-Utilitarios campo Fecha

    return (
        <React.Fragment>
            
            <div className={styles['w3-container']}>
                <div className={styles['w3-modal']} style={{ display: mostrar ? 'block' : 'none' }}>
                    <div className={styles['w3-modal-content']} >
                        <div className={styles['w3-header']} />
                        <div className={styles['w3-container']} style={{ padding: '0.5em 1em 1.5em 1em' }}>
                            {/*CMUNAYLLA: validacion para diferenciar textos de apoderado y beneficiarios*/}
                            {codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO ?
                                <p className={styles['w3title']}>
                                    {state.beneficiariosApoderado.length === 0 ? 'Agregar apoderado' : 'Editar apoderado'}
                                </p>
                                :
                                <p className={styles['w3title']}>
                                    {benefSeleccionado === null || benefSeleccionado === undefined ? 'Agregar nuevo beneficiario' : 'Editar beneficiario'}
                                </p>
                            }

                            <div className={`${styles['flex-container']}`}>
                                {/* Tipo de documento */}
                                <div className={`${styles['flex5']}`}>
                                    <label >Tipo Doc.&nbsp;{codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_UNICO || codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO
                                        ? '*' : ''}</label>
                                    <select
                                        className={!state.campoValidado.tipoDocumento ?
                                            `${styles['logerror']}` : styles['']
                                        }
                                        value={state.beneficiarioSeleccionado !== null &&
                                            state.beneficiarioSeleccionado.tipoDocumento !== undefined &&
                                            state.beneficiarioSeleccionado.tipoDocumento !== null ?
                                            state.beneficiarioSeleccionado.tipoDocumento.codigo : -1}
                                        onChange={(e) => handleChangeComboCustom(e, 'tipoDocumento')}
                                        disabled={stateLocal.estaCargando.documentos}>
                                        <option value={-1}>Seleccione</option>
                                        {documentos && documentos.length > 0 &&
                                            documentos.filter(documento => documento.id !== 2 && documento.id !== 5 && documento.id !== 4).map(
                                                documentoFiltrado => (
                                                    <option key={documentoFiltrado.id} value={documentoFiltrado.id}>
                                                        {documentoFiltrado.valor}
                                                    </option>
                                                )
                                            )
                                        }
                                    </select>
                                    {!state.campoValidado.tipoDocumento &&
                                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_TIP_DOCUMENTO}</span>
                                    }
                                </div>
                                {/* Numero de documento */}
                                <div className={styles['flex5']}>
                                    <label >Nro. Doc.&nbsp;{codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_UNICO ? '*' : ''}</label>
                                    <input type='text'
                                        className={!state.campoValidado.numeroDocumento || !tamanioDoc.estado ? styles['logerror'] : styles['']}
                                        value={state.beneficiarioSeleccionado !== null
                                            ? state.beneficiarioSeleccionado.numeroDocumento || '' : ''}
                                        maxLength={obtenerTamanoNumDocumento(state.beneficiarioSeleccionado, 'tipoDocumento', 'numeroDocumento')}
                                        onChange={(e) => handleNumeroDocumento(e, 'numeroDocumento')}
                                        onBlur={(e) => handleBlurPersonID()}
                                    />
                                    {!state.campoValidado.numeroDocumento &&
                                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_NUM_DOCUMENTO}</span>
                                    }
                                    {!tamanioDoc.estado &&
                                        <span className={styles['span-error']}>{tamanioDoc.descripcion}</span>
                                    }
                                </div>
                            </div>
                            <div className={`${styles['flex-container']}`}>
                                {/* Nombres */}
                                <div className={`${styles['flex10']}`}>
                                    <label>Nombres&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                                    <input type='text'
                                        className={!state.campoValidado.nombres ? styles['logerror'] : null}
                                        value={state.beneficiarioSeleccionado !== null
                                            ? state.beneficiarioSeleccionado.nombres || '' : ''}
                                        onChange={(e) => handleChangeTexto(e, 'nombres')}
                                        maxLength={codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO ? 50 : 40} />
                                    {!state.campoValidado.nombres &&
                                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_NOMBRES}</span>
                                    }
                                </div>
                            </div>
                            <div className={`${styles['flex-container']}`}>
                                {/* Apellido Paterno */}
                                <div className={`${styles['flex5']}`}>
                                    <label>Ap. Paterno&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                                    <input type='text'
                                        className={!state.campoValidado.apellidoPaterno ? styles['logerror'] : null}
                                        value={state.beneficiarioSeleccionado !== null
                                            ? state.beneficiarioSeleccionado.apellidoPaterno || '' : ''}
                                        onChange={(e) => handleChangeTexto(e, 'apellidoPaterno')}
                                        maxLength={codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO ? 40 : 30} />
                                    {!state.campoValidado.apellidoPaterno &&
                                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_APE_PATERNO}</span>
                                    }
                                </div>
                                {/* Apellido Materno */}
                                <div className={`${styles['flex5']}`}>
                                    <label>Ap. Materno&nbsp;
                                        {
                                            !state.beneficiarioSeleccionado ? Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS :
                                                state.beneficiarioSeleccionado && state.beneficiarioSeleccionado.tipoDocumento &&
                                                    state.beneficiarioSeleccionado.tipoDocumento.codigo !== 3 ?
                                                    Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : ''
                                        }
                                    </label>
                                    <input type='text'
                                        className={!state.campoValidado.apellidoMaterno ? styles['logerror'] : null}
                                        value={state.beneficiarioSeleccionado !== null
                                            ? state.beneficiarioSeleccionado.apellidoMaterno || '' : ''}
                                        onChange={(e) => handleChangeTexto(e, 'apellidoMaterno')}
                                        maxLength={codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO ? 40 : 30} />
                                    {!state.campoValidado.apellidoMaterno &&
                                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_APE_MATERNO}</span>
                                    }
                                </div>
                            </div>
                            <div className={`${styles['contenedor4']}`}>
                                {/* Sexo */}
                                <div className={styles['flex5']}>
                                    <label>Sexo&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                                    <form>
                                        <div className={styles["centered"]} style={{ width: '50%', paddingLeft: '3%' }}>
                                            <label className={styles['label-radio']}>
                                                <input type='radio'
                                                    name='sexo'
                                                    value={0}
                                                    selected={state.beneficiarioSeleccionado !== null &&
                                                        state.beneficiarioSeleccionado.sexo !== undefined
                                                        ? state.beneficiarioSeleccionado.sexo.codigo === 0
                                                        : false}
                                                    checked={state.beneficiarioSeleccionado !== null &&
                                                        state.beneficiarioSeleccionado.sexo !== undefined
                                                        ? state.beneficiarioSeleccionado.sexo.codigo === 0
                                                        : false}
                                                    onChange={handleChangeSexo} />
                                                <div style={{ lineHeight: '35px', marginLeft: '0.75em' }}>
                                                    Femenino
                                                </div>
                                            </label>
                                            <label className={styles['label-radio']}>
                                                <input type='radio'
                                                    name='sexo'
                                                    value={1}
                                                    selected={state.beneficiarioSeleccionado !== null &&
                                                        state.beneficiarioSeleccionado.sexo !== undefined
                                                        ? state.beneficiarioSeleccionado.sexo.codigo === 1
                                                        : false}
                                                    checked={state.beneficiarioSeleccionado !== null &&
                                                        state.beneficiarioSeleccionado.sexo !== undefined
                                                        ? state.beneficiarioSeleccionado.sexo.codigo === 1
                                                        : false}
                                                    onChange={handleChangeSexo} />
                                                <div style={{ lineHeight: '35px', marginLeft: '0.75em' }}>
                                                    Masculino
                                                </div>
                                            </label>
                                        </div>
                                        {!state.campoValidado.sexo &&
                                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_SEXO}</span>
                                        }
                                    </form>
                                </div>
                                {/* Fecha de nacimiento Actualizado sin utilizar componente*/}
                                <div className={styles['box1']}>
                                    <div className={!state.campoValidado.fechaNacimiento ? styles.caja2 : styles.caja}>
                                        <label>Fecha Nacimiento&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                                        <DatePicker
                                            maximumDate={utils().getToday()}
                                            value={(state.beneficiarioSeleccionado !== null && state.beneficiarioSeleccionado.fechaNacimiento) ?
                                                Funciones.transformarFechaToDatePicker(state.beneficiarioSeleccionado.fechaNacimiento)
                                                : null}
                                            onChange={(value) => onChangeInputDate(value)}
                                            shouldHighlightWeekends
                                            colorPrimary="#0fbcf9"
                                            calendarClassName="responsive-calendar"
                                            calendarPopperPosition="bottom"
                                            inputPlaceholder="DD/MM/AAAA"
                                            formatInputText={obtenerFormatoFecha}
                                            disabled={false}
                                            locale={myCustomLocale}
                                        />
                                        {!state.campoValidado.fechaNacimiento && (
                                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_FEC_NACIMIENTO}</span>
                                        )}
                                        {codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO && edadExacta < 18 && (
                                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_FEC_NACIMIENTO}</span>
                                        )}
                                        {/*CORRECCION DE VALIDACION FEC NAC */}
                                        {codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_UNICO && edadBene > edadFU && año !== null && (
                                            <span className={styles['span-error']}>{'La edad máxima del beneficiario es ' + edadFU + ' años'}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles['flex-container']}`}>
                                {/* Parentesco */}
                                <div className={styles['flex5']}>
                                    <label>Parentesco&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                                    <select
                                        className={!state.campoValidado.parentesco
                                            ? `${styles['logerror']} ${styles['tipoDoc']}`
                                            : stateLocal.estaCargando.parentescos
                                                ? `${styles['loading']} ${styles['tipoDoc']}`
                                                : styles['tipoDoc']}
                                        value={(state.beneficiarioSeleccionado && state.beneficiarioSeleccionado.parentesco) ?
                                            state.beneficiarioSeleccionado.parentesco.codigo : -1}
                                        onChange={(e) => handleChangeComboCustom(e, 'parentesco')}
                                        disabled={stateLocal.estaCargando.parentescos ||
                                            stateLocal.deshabilitados.parentescos}>
                                        <option value={-1}>Seleccione</option>
                                        {stateLocal.combos.parentescos && stateLocal.combos.parentescos.length > 0
                                            && stateLocal.combos.parentescos.map(parentesco => (
                                                <option key={parentesco.id} value={parentesco.id}>
                                                    {parentesco.valor}
                                                </option>
                                            ))}
                                    </select>
                                    {!state.campoValidado.parentesco &&
                                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_PARENTESCO}</span>
                                    }
                                </div>

                                {/* Porcentaje */}
                                <div className={styles['flex5']}>
                                    {codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL ||
                                        codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE
                                        ? <React.Fragment>
                                            <label>Porcentaje %&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                                            <input type='number'
                                                step='0.01'
                                                placeholder='0.00'
                                                className={!state.campoValidado.porcentajeBeneficio ? styles['logerror'] : null}
                                                value={state.beneficiarioSeleccionado !== null
                                                    ? state.beneficiarioSeleccionado.porcentajeBeneficio || '' : ''}
                                                onInput={(e) => longitud(e)}
                                                onChange={(e) => handleChangePorcentaje(e, 'porcentajeBeneficio')} />
                                        </React.Fragment>
                                        : null
                                    }
                                    {!state.campoValidado.porcentajeBeneficio &&
                                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_PORCENTAJE}</span>
                                    }
                                </div>
                            </div>
                            <div className={`${styles['flex-container']} ${styles['reverse']}`}>
                                {codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO ? //validacion para apoderado
                                    <button className={`${styles['flex5']} ${styles['default']} ${styles['call-to-action']}`} onClick={validarFormulario}>
                                        {state.beneficiariosApoderado.length === 0
                                            ? 'Agregar' : 'Actualizar'
                                        }
                                    </button>
                                    :   //validacion para los otros beneficiarios
                                    <button className={`${styles['flex5']} ${styles['default']} ${styles['call-to-action']}`} onClick={validarFormulario}>
                                        {state.beneficiarioSeleccionado === null || state.beneficiarioSeleccionado.idBeneficiario === undefined ||
                                            state.beneficiarioSeleccionado.idBeneficiario === null
                                            ? 'Agregar' : 'Actualizar'
                                        }
                                    </button>
                                }

                                <button className={`${styles['flex5']} ${styles['default']}`} onClick={handleCerrarModal}>Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal mostrarModal={mostrarModal} setModal={setModal} textos={textos} />
            <Modal mostrarModal={mostrarModal2} setModal={setModal2} textos={textos2} />
            {mostrarPersonas &&
                <ModalValidacionPersonas
                    viap={state.viap}
                    personID={state.personID}
                    accion={personaSeleccionada}
                />
            }
        </React.Fragment>
    )
}

export default BeneficiarioModal
